import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import MocList from "@/pages/MocList";
import MocDetail from "@/pages/MocDetail";
import NewMoc from "@/pages/NewMoc";
import Validations from "@/pages/Validations";
import Actions from "@/pages/Actions";
import Pssr from "@/pages/Pssr";
import Notifications from "@/pages/Notifications";
import Register from "@/pages/Register";
import Admin from "@/pages/Admin";
import Aide from "@/pages/Aide";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-12 h-12 rounded-sm border-2 border-primary flex items-center justify-center font-black animate-pulse text-primary">MOC</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/mocs" element={<Protected><MocList /></Protected>} />
      <Route path="/moc/new" element={<Protected><NewMoc /></Protected>} />
      <Route path="/moc/:id" element={<Protected><MocDetail /></Protected>} />
      <Route path="/validations" element={<Protected><Validations /></Protected>} />
      <Route path="/actions" element={<Protected><Actions /></Protected>} />
      <Route path="/pssr" element={<Protected><Pssr /></Protected>} />
      <Route path="/pssr/:id" element={<Protected><Pssr /></Protected>} />
      <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
      <Route path="/register" element={<Protected><Register /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="/aide" element={<Protected><Aide /></Protected>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
